export default "__VITE_ASSET__bd185c9d__"